export const INTEGRATION_TYPE = Symbol('INTEGRATION_TYPE');

export const DETERMINE_INTEGRATION_TYPE = Symbol('DETERMINE_INTEGRATION_TYPE');

export const GET_CUSTOMER_IP = Symbol('GET_CUSTOMER_IP');
